import React from "react";
import "../../Button/Button.css";

const Index = ({
  buttonText2,
  buttonText1,
  _class,
  pageLink,
  isSubmit,
  disabled,
  _linkClass,
  _disable,
  handleSubmit, 
}) => {
  return (
    <>
      {isSubmit ? (
        
          <button
            onClick={handleSubmit}
            className={`btn-epic ${_class}`}
            disabled={Boolean(_disable || disabled)}
          >
            <span>{buttonText1 || 'Submit'}</span>
            <span>{buttonText2 || 'Submit'}</span>
          </button>
      ) : pageLink ? (
        <a href={pageLink} className={`${_linkClass}`} >
          <div className={`btn-epic ${_class}`}>
            <span>{buttonText1}</span>
            <span>{buttonText2 || buttonText1}</span>
          </div>
        </a>
      ) : (
        <div className={`btn-epic ${_class}`} >
          <span>{buttonText1}</span>
          <span>{buttonText2 || buttonText1}</span>
        </div>
      )}
    </>
  );
};

export default Index;
